import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';

import CargomaticModal from 'components/v2/modal';
import AppointmentPicker from 'components/ui/tailwind/AppointmentPicker';
export default function LaneRatesAppointmentWindowModal({
  show,
  onClose,
  validity,
  onStartChange,
  onEndChange,
}) {
  const { t } = useTranslation();
  // need to modify once we have the updated validity
  const getBody = () => {
    const startTime = validity.effectiveStart
      ? moment(validity.effectiveStart)
      : null;
    const endTime = validity.effectiveEnd
      ? moment(validity.effectiveEnd)
      : null;
    const start = startTime && startTime.isValid() ? startTime : null;
    const end = endTime && endTime.isValid() ? endTime : null;
    return (
      <div data-testid="div-b49f376a" className="flex justify-center">
        <AppointmentPicker
          dataTestId="AppointmentPicker-43b48f7f"
          start={start}
          end={end}
          confirmed={false}
          onStartChange={onStartChange}
          onEndChange={onEndChange}
          onToggleConfirmed={() => {}}
          hideConfirm={onClose} />
      </div>
    );
  };

  const getFooter = () => {
    return (
      <button
        data-testid="button-3e28c329"
        className="button button-green"
        onClick={onClose}>
        {t('DONE')}
      </button>
    );
  };

  return (
    <CargomaticModal
      dataTestId="CargomaticModal-0a8945dd"
      title={t('LANE_RATE_VALIDITY')}
      style={{ top: '30%' }}
      show={show}
      onHide={onClose}
      body={getBody()}
      footer={getFooter()} />
  );
}

LaneRatesAppointmentWindowModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  validity: PropTypes.object,
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
};
